export default {
    productTab: ({ component }) => {
        if (!component) return component;
        component.tabGtmActions = new Map([
            [
                'tabClick',
                {
                    gtmCategory: 'linkClick',
                    gtmId: 'product-type-bar',
                },
            ],
        ]);

        return component;
    },
    pageView: ({ slugInfo, subVanityUrl }) => {
        try {
            if (slugInfo.templateKey !== 'sale-v3') {
                return {};
            }

            let vanityUrlPrefixRegex = /^slp\//i;
            let keyAndTabSegmentFromVanityUrl =
                subVanityUrl &&
                vanityUrlPrefixRegex.test(subVanityUrl) &&
                subVanityUrl.replace(vanityUrlPrefixRegex, '');

            return {
                ...(keyAndTabSegmentFromVanityUrl && { simple_title: keyAndTabSegmentFromVanityUrl }),
            };
        } catch (e) {}

        return {};
    },
};
